module.exports = __webpack_public_path__ + "officialStatic/img/cahngchengLogo.d120721.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/cahngchengLogo.png
// module id = BCO2
// module chunks = 0